import { Download, Eye, FileArchive, FileImage, FileSpreadsheet, FileText } from "lucide-react";
import { fileExt, isArchive } from "../../lib/files";
import { formatDateTime, formatSize } from "../../lib/format";
import { ArchiveTag } from "../ArchiveTag";

const ICONS = { xls: FileSpreadsheet, xlsx: FileSpreadsheet, jpg: FileImage, jpeg: FileImage, png: FileImage, zip: FileArchive, rar: FileArchive, "7z": FileArchive };

const ActionBtn = ({ icon: Icon, label, onClick, testId, danger }) => (
  <button type="button" onClick={onClick} data-testid={testId} className={`${danger ? "tr-btn-danger" : "tr-btn-light"} px-2.5 py-1.5 text-xs`}>
    <Icon className="h-3.5 w-3.5" />
    {label}
  </button>
);

export const FileRow = ({ file, busy, onView, onDownload, canDownload }) => {
  const Icon = ICONS[fileExt(file.original_filename)] || FileText;
  return (
    <li className={`flex flex-col gap-2.5 rounded-[12px] border border-[#e8edf5] bg-[#fbfcfe] p-3 sm:flex-row sm:items-center ${busy ? "opacity-60" : ""}`} data-testid={`file-row-${file.id}`}>
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#eef4ff] text-[#0f5ef7]">
          <Icon className="h-4.5 w-4.5" />
        </span>
        <div className="min-w-0">
          <div className="flex min-w-0 items-center gap-2">
            <div className="truncate text-sm font-semibold text-[#182235]" title={file.original_filename} data-testid={`file-name-${file.id}`}>{file.original_filename}</div>
            {isArchive(file.original_filename) && <ArchiveTag testId={`file-archive-tag-${file.id}`} />}
            {file.ai_reason && (
              <span title={`IA: ${file.ai_reason}`} className="rounded-full bg-[#eef4ff] px-1.5 py-0.5 text-[10px] font-bold text-[#0f5ef7]" data-testid={`file-ai-tag-${file.id}`}>IA</span>
            )}
          </div>
          <div className="text-xs text-[#5b667a]" data-testid={`file-meta-${file.id}`}>
            {file.size > 0 && `${formatSize(file.size)} · `}{formatDateTime(file.uploaded_at)} · {file.uploaded_by}
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {file.viewable && <ActionBtn icon={Eye} label="Ver" onClick={() => onView(file)} testId={`file-view-${file.id}`} />}
        {canDownload && <ActionBtn icon={Download} label="Descargar" onClick={() => onDownload(file)} testId={`file-download-${file.id}`} />}
      </div>
    </li>
  );
};
